import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row justify-content-center"
}
const _hoisted_2 = { class: "col col-lg-7" }
const _hoisted_3 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md" }
const _hoisted_6 = { class: "col-md mt-3 mt-md-0" }
const _hoisted_7 = { class: "row mt-3" }
const _hoisted_8 = { class: "col-md" }
const _hoisted_9 = { class: "mt-5 p-5 bg-info flex-grow-1 rounded" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-start mb-2" }, [
  /*#__PURE__*/_createVNode("h2", null, "Roller")
], -1)
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { class: "mt-4 p-5 bg-info flex-grow-1 rounded" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-start mb-2" }, [
  /*#__PURE__*/_createVNode("h2", null, "Roller på vegne af")
], -1)
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "text-muted" }
const _hoisted_17 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "col col-lg-7" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-center p-5" }, [
    /*#__PURE__*/_createVNode("h3", null, "Brugerprofil ikke tilgængelig"),
    /*#__PURE__*/_createVNode("p", { class: "text-muted" }, " Vi kan ikke vise din profil på nuværende tidspunkt. Dette kan skyldes at du ikke er logget korrekt ind. "),
    /*#__PURE__*/_createVNode("p", { class: "text-muted" }, [
      /*#__PURE__*/_createTextVNode(" Prøv at "),
      /*#__PURE__*/_createVNode("a", { href: "javascript:location.reload()" }, "genindlæse siden"),
      /*#__PURE__*/_createTextVNode(" eller kontakt support hvis problemet fortsætter. ")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_error = _resolveComponent("error")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_component_page, {
    isLoading: $setup.loading,
    error: $setup.staticError
  }, {
    default: _withCtx(() => [
      ($setup.user && $setup.user.firstname)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_app_header, { title: "Din brugerprofil" }, {
                subtitle: _withCtx(() => [
                  ($setup.user.organization)
                    ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString($setup.user.organization.name) + " - " + _toDisplayString($setup.user.organization.vat), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode("form", null, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode(_component_o_field, {
                      variant: $setup.v$.firstname.$error ? 'danger' : '',
                      label: "Fornavn *"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_o_input, {
                          modelValue: $setup.user.firstname,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.user.firstname = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["variant"])
                  ]),
                  _createVNode("div", _hoisted_6, [
                    _createVNode(_component_o_field, {
                      variant: $setup.v$.lastname.$error ? 'danger' : '',
                      label: "Efternavn *"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_o_input, {
                          modelValue: $setup.user.lastname,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.user.lastname = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["variant"])
                  ])
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_o_field, { label: "Mailadresse *" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_o_input, {
                          modelValue: $setup.user.email,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.user.email = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_DataTable, {
                  sortField: "name",
                  stripedRows: true,
                  sortOrder: 1,
                  responsiveLayout: "scroll",
                  value: $setup.userRoles,
                  class: "text-start",
                  selectionMode: "single"
                }, {
                  empty: _withCtx(() => [
                    _createVNode(_component_error, { error: {
                  title: 'Ingen roller',
                  message: 'Du er ikke tilknyttet nogle roller endnu',
                } })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "name",
                      sortable: true
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode("div", _hoisted_11, [
                          _createVNode("small", _hoisted_12, _toDisplayString(data.organizationName) + " - " + _toDisplayString(data.applicationName), 1),
                          _createTextVNode(" " + _toDisplayString(data.roleName), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_DataTable, {
                  sortField: "name",
                  stripedRows: true,
                  sortOrder: 1,
                  responsiveLayout: "scroll",
                  value: $setup.onBehalfOfRoles,
                  class: "text-start",
                  selectionMode: "single"
                }, {
                  empty: _withCtx(() => [
                    _createVNode(_component_error, { error: {
                  title: 'Ingen roller på vegne af',
                  message:
                    'Du har ikke roller der kan anvendes på vegne af andre',
                } })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "name",
                      sortable: true
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode("div", _hoisted_15, [
                          _createVNode("small", _hoisted_16, _toDisplayString(data.organizationName) + " - " + _toDisplayString(data.applicationName), 1),
                          _createTextVNode(" " + _toDisplayString(data.roleName), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ])
          ]))
        : (!$setup.loading && !$setup.staticError)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _hoisted_18
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["isLoading", "error"]))
}